
// Persistent store field
export default [
  ['recruitment'],
]
